<template>
<div class="tg-coupon pos-r flex-container text-orange"
     style="background-image: url('//image1.51tiangou.com/tgou2/img2/coupon/bg-fission-coupon.png')"
	 :data-theme="theme()">
    <span class="pos-a tg-coupon-type fs-12 top0 left0" style="background: #ffebc4">
        {{data.detailSubName}}
    </span>
    <div class="tg-coupon-price flex-container">
        <div v-if="data.detailType==='cash'" style="width: 75px">
            <div class="fs-20 line text-center" style="line-height: 33px;margin-top: 10px">
                <span class="lh-20 fs-16">¥</span>
                <span style="font-size: 32px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;max-width: 80px;" v-text="data.detailDes | splitPriceInt"></span>
                <span v-text="data.detailDes | splitPrice"></span>
            </div>
            <div class="fs-12 text-center" v-text="data.detailTips" style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 90px;"></div>
        </div>
        <div v-if="data.detailType==='discount'" style="width: 75px">
            <div class="fs-20 line text-center" style="line-height: 33px;margin-top: 10px">
                <span style="font-size: 33px;" v-text="data.detailDes | splitPriceInt"></span>
                <span v-text="data.detailDes | splitPrice"></span>
                <span class="fs-12">折</span>
            </div>
            <div class="fs-12 text-center" v-text="data.detailTips"></div>
        </div>
        <div v-if="data.detailType==='text'" style="width: 75px">
            <div class="fs-20 line text-center" style="line-height: 32px;margin-top: 10px">
                <span style="font-size: 33px;" v-text="data.detailDes | splitPriceInt"></span>
                <span v-text="data.detailDes | splitPrice"></span>
            </div>
            <div class="fs-10" v-text="data.detailTips"></div>
        </div>
        <div class="flex1" style="margin-left: 17px">
            <div class="tg-coupon_title text-limit1 fs-14" v-text="data.detailName"></div>
            <div v-if="!data.canReceived && data.received">
                <img src="//image1.51tiangou.com/tgou2/img2/coupon/coupon-yilingqu.png" alt="" style="width: 60px;height: 60px;position: absolute;top: 0;right: 0;">
            </div>
            <div class="tg-coupon_store fs-12 text-limit1" style="margin-bottom: 12px" v-text="data.storeName"></div>
            <div class="fs-11" :style="{color: isFission ? '#ffb47e' : '#ff7684'}" v-text="data.timeStr"></div>
        </div>
    </div>
    <div class="pos-r" style="line-height: 66px">
        <div v-text="opText()" v-if="opText()" class="fs-16" @click="getCoupon(data)"></div>
        <div v-if="opText() && isWeixin && theme()!=='grey'" class="pos-a top0 left0" style="width: 64px;height: 66px;" v-html="wxapp()"></div>
    </div>
</div>
</template>

<script>
import {maple, domain, app} from 'tgPage';

let isWeixin = maple.device.weixin
	, protocol = location.protocol;

export default {
	props: {
		data: {
			type: Object
			, default: null
		}
		, productId: {
			type: String
			, default: ''
		}
		, storeId: {
			type: String
			, default: ''
		}
	}
	, data(){
		return {
			isWeixin
			, isHybrid: maple.cookie('hybrid') === 'true'
			, webcast: {
				userName: domain.webcast.userName
				, path: `${domain.webcast.product}.html`
			}
		}
	}
	, methods: {
		getCoupon(data){
			if( !data.canReceived ){
				return;
			}

			if( this.isHybrid ){
				app.startWxapp({
					userName: domain.userName
					, path: domain.webcast.product
				});

				return ;
			}

			maple.pageIns.changePage('/zhuli.html#/zhuli');
            // data.canReceived && this.$dispatch('getCoupon', data);
		}
		, wxapp(){
			return `<wx-open-launch-weapp
 username="${this.webcast.userName}"
 path="${this.webcast.path}?productId=${this.productId}&openClist=1${this.storeId?'&storeId='+this.storeId:''}">
	<script type="text/wxtag-template">
		<div style="background: transparent;height: 66px;width: 634px;color: transparent;">分享领取</div>
	<\/script>
</wx-open-launch-weapp>`;
		}
		, theme(){
			if(!this.data.canReceived && !this.data.received){
				return 'grey';
			} else{
				return this.data.colorType;
			}
		}
		, opText(){
			return this.data.canReceived ? '分享领取': (this.data.received ? '' : '已抢光')
		}
	}
	, computed: {
		// theme(){
		// 	if(!this.data.canReceived && !this.data.received){
		// 		return 'grey';
		// 	} else{
        //         return this.data.c olorType;
		// 	}
		// }
		// , opText(){
		// 	return this.data.canReceived ? '分享领取': (this.data.received ? '' : '已抢光')
		// }
		// , path(){
		// 	return `${this.webcast.path}?productId=${this.productId}&openClist=1${this.storeId?'&storeId='+this.storeId:''}`;
		// }
// 		, wxapp(){
// 			return `<wx-open-launch-weapp
//  						 username="${this.webcast.userName}"
//  						 path="${this.webcast.path}?productId=${this.productId}&openClist=1${this.storeId?'&storeId='+this.storeId:''}">
// 	<script type="text/wxtag-template">
// 		<div style="background: transparent;height: 22px;width: 60px;">分享领取</div>
// 	<\/script>
// </wx-open-launch-weapp>
//
// <wx-open-launch-weapp username="${domain.webcast.userName}"
//   path="${domain.webcast.path +'.html'}">
// <script type="text/wxtag-template">
// <img src="${protocol}//image1.51tiangou.com/tgou2/img2/webcast/icon-webcast.png"
//  width="26"
//  height="22"
//  style="display: block;margin: 2px auto 0;"
//  alt="">
// <div style="font-size: 11px;color: #666;text-align: center;">直播</div>
// <\/script>
// </wx-open-launch-weapp>`;
// 		}
	}
};
</script>

<style lang="scss">
.tg-coupon:before,
.tg-coupon:after{
	position: absolute;
	left: 94px;
	height: 12px;
	width: 12px;
	border: 1px solid;
	border-radius: 50%;
	background: #fff;
	content: "";
	transform: rotate(-45deg);
	-webkit-transform: rotate(-45deg);
}
.tg-coupon:before{
	top: -5px;
	border-top-color: #fff;
	border-right-color: #fff;
}
.tg-coupon:after{
	bottom: -5px;
	border-bottom-color: #fff;
	border-left-color: #fff;
}
.tg-coupon_discount{
	height: 95px;
	width: 100px;
	border: 1px solid;
	border-right: 0;
    z-index: -1;
}
.tg-coupon_discount:after{
    position: absolute;
    content: '';
    width: 8px;
    height: 80px;
    background: radial-gradient(#fff 0px, #fff 2px, rgba(0, 0, 0, 0) 2px, rgba(0, 0, 0, 0) 2px);
    background-size: 9px 9px;
    background-position: -9px -9px;
    left: 94px;
    top: 6px;
}
.tg-coupon_desc{
	height: 95px;
	border: 1px solid;
	border-left: 0;
}
.tg-coupon_title .badge{
	height: 13px;
	padding: 0 5px;
	font-size: 10px;
	line-height: 13px;
}
.tg-coupon_operate{
	height: 22px;
	line-height: 22px;
	border-radius: 10px;
}

/* 红色皮肤 */
.tg-coupon[data-theme="red"]:before{
	border-bottom-color: #ff8c8d;
	border-left-color: #ff8c8d;
}
.tg-coupon[data-theme="red"]:after{
	border-top-color: #ff8c8d;
	border-right-color: #ff8c8d;
}
.tg-coupon[data-theme="red"] .tg-coupon_discount{
	border-color: #ff8c8d;
	background: #ff8c8d;
	color: #fff;
}
.tg-coupon[data-theme="red"] .tg-coupon_desc{
	border-color: #ff8c8d;
}
.tg-coupon[data-theme="red"] .tg-coupon_title .badge{
	background: #ff8c8d;
}
.tg-coupon[data-theme="red"] .tg-coupon_operate{
	background: #ff8c8d;
}

/* 蓝色皮肤 */
.tg-coupon[data-theme="blue"]:before{
	border-bottom-color: #3fbafa;
	border-left-color: #3fbafa;
}
.tg-coupon[data-theme="blue"]:after{
	border-top-color: #3fbafa;
	border-right-color: #3fbafa;
}
.tg-coupon[data-theme="blue"] .tg-coupon_discount{
	border-color: #3fbafa;
	background: #3fbafa;
	color: #fff;
}
.tg-coupon[data-theme="blue"] .tg-coupon_desc{
	border-color: #3fbafa;
}
.tg-coupon[data-theme="blue"] .tg-coupon_title .badge{
	background: #3fbafa;
}
.tg-coupon[data-theme="blue"] .tg-coupon_operate{
	background: #3fbafa;
}

/* 灰色皮肤 */
.tg-coupon[data-theme="grey"]:before{
	border-bottom-color: #cdcdcd;
	border-left-color: #cdcdcd;
}
.tg-coupon[data-theme="grey"]:after{
	border-top-color: #cdcdcd;
	border-right-color: #cdcdcd;
}
.tg-coupon[data-theme="grey"] .tg-coupon_discount{
	border-color: #cdcdcd;
	background: #cdcdcd;
	color: #fff;
}
.tg-coupon[data-theme="grey"] .tg-coupon_desc{
	border-color: #cdcdcd;
}
.tg-coupon[data-theme="grey"] .tg-coupon_title .badge{
	background: #cdcdcd;
}
.tg-coupon[data-theme="grey"] .tg-coupon_operate{
	background: #cdcdcd;
}
</style>